import { generatePath } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ROUTES_PATH from 'domain/router/routesPathConfig';
import { SEARCH_TYPES, searchTextSelector, searchTypeSelector } from 'domain/companies';

type GetPathToCompany = {
  searchType: string;
  searchText: string;
  companyId: string;
};

const getPathToCompany = ({ searchType, searchText, companyId }: GetPathToCompany) => {
  const pathBase = generatePath(ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.absolute, { companyId });

  const pathAllCategory = generatePath(ROUTES_PATH.COMPANY_WORKSPACE.absolute, { companyId, category1: 30 });

  switch (searchType) {
    case SEARCH_TYPES.byDocumentText:
      return searchText && searchText.length > 2 ? `${pathAllCategory}?stag[]=${searchText}` : pathBase;
    case SEARCH_TYPES.byCompany:
    default:
      return pathBase;
  }
};

const useGetCompanyPathTo = (isErpConnected: boolean, companyId?: string) => {
  const searchText = useSelector(searchTextSelector);
  const searchType = useSelector(searchTypeSelector);

  if (!companyId) return undefined;

  const pathToCompany = getPathToCompany({
    searchType,
    searchText,
    companyId,
  });
  const pathToSettings = generatePath(ROUTES_PATH.COMPANY_SETTINGS_INTEGRATIONS.absolute, {
    companyId,
  });
  return isErpConnected ? pathToCompany : pathToSettings;
};

export default useGetCompanyPathTo;
